import React, { useEffect, useState } from 'react';
import Header from '../../layouts/Header';
import { Col, Form, Row, Button, Dropdown, Modal, Spinner, Card, ListGroup, Table, Badge } from 'react-bootstrap';
import ReusableTable from '../../components/ReusableTable';
import axiosInstance from '../../api/axios';
import { toast } from 'react-toastify';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import makeAnimated from "react-select/animated";
import { format, isAfter, isBefore, parseISO, addDays } from 'date-fns';
import * as XLSX from 'xlsx';
import MultiSelectComponent from '../../components/MultiSelectComponent'
import debounce from 'lodash/debounce';
import EditModal1 from './EditModal1';
import { useSelector } from 'react-redux';

const UserCoupon1 = () => {

    const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
    const [skin, setSkin] = useState(currentSkin);
    const { access } = useSelector((state) => state.login);
    const { loginEmail } = useSelector((state) => state.login);
    const email = loginEmail || localStorage.getItem("email");
    const [couponAccess, setCouponAccess] = useState([]);

    const accessToken = localStorage.getItem("authToken");
    const animatedComponents = makeAnimated();
    const [usersList, setUsersList] = useState([]);
    const [usersFromFile, setUsersFromFile] = useState([]);
    const [productsList, setProductsList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [universalCoupon, setUniversalCoupon] = useState(false);
    const [couponData, setCouponData] = useState({
        isBogoCoupon: false,
        isSizeUpgradeCoupon: false,
        sizeUpgradeAddon: "",
        newSizeUpgradeAddon: "",
        title: "",
        description: "",
        usageType: "",
        orderType: "ALL",
        couponCode: "",
        discountPercent: "",
        dayOfWeek: "",
        discountAmount: "",
        validityStartDate: "",
        validityEndDate: "",
        dailyUsageLimit: "",
        startTime: "",
        endTime: "",
        discountPrice: "",
        applicableQuantityType: "",
        termsAndConditions: [],
        isComboCategoryCoupon: false,
        maxAddonsAllowed: null,
        maxDiscountAmount: "",
        minOrderAmount: "",
        isMrpDiscount: false,
        isFreebieCoupon: false,
        freebieProduct: "",
        freebieQuantity: "",
        excludedAddons: [],
        isHidden: "false"
    });
    const [selections, setSelections] = useState({
        selectedIncludedOutlets: [],
        selectedExcludedOutlets: [],
        selectedApplicableCategories: [],
        selectedApplicableProducts: [],
        selectedDependentCategories: [],
        selectedDependentProducts: [],
        selectedExcludedProducts: [],
        selectedApplicableLevels: [],
        primaryComboCategories: [],
        secondaryComboCategories: []
    });
    const [currentTerm, setCurrentTerm] = useState('');
    const [addonList, setAddonList] = useState([]);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [addNewOpenModal, setAddNewOpenModal] = useState(false);
    const [userCouponAllocationData, setUserCouponAllocationData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [openViewModal, setOpenViewModal] = useState(false);
    const [couponUsers, setCouponUsers] = useState([]);
    const [couponDetails, setCouponDetails] = useState({});
    const [openEditModal, setOpenEditModal] = useState(false);
    const [userCouponId, setUserCouponId] = useState("");
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [userCouponAllocationId, setUserCouponAllocationId] = useState("");
    const [isDeleteBtnLoading, setIsDeleteBtnLoading] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [pagination, setPagination] = useState({
        page: 1,
        rowsPerPage: 10,
        totalRecords: 0,
        totalPages: 0
    });
    const [file, setFile] = useState(null);
    const [outlets, setOutlets] = useState([]);
    const [selectedLevelOptions, setSelectedLevelOptions] = useState([]);
    const [levels, setLevels] = useState([]);
    const [primaryComboCategories, setPrimaryComboCategories] = useState([])
    const [secondaryComboCategories, setSecondaryComboCategories] = useState([]);
    const [editSelections, setEditSelections] = useState({
        selectedIncludedOutlets: [],
        selectedExcludedOutlets: [],
        selectedAddonValues: [],
        selectedApplicableLevels: [],
        primaryComboCategories: [],
        secondaryComboCategories: []
    });
    const [updatingData, setUpdatingData] = useState(null);
    const [exProductList, setExProductList] = useState([]);
    const [selectedDependentCategories, setSelectedDependentCategories] = useState([]);
    const [selectedDependentProducts, setSelectedDependentProducts] = useState([]);
    const [selectedExcludedProducts, setSelectedExcludedProducts] = useState([]);
    const [isDeleteLoading, setIsDeleteLoading] = useState(false);
    const [newSizeAddonsList, setNewSizeAddonsList] = useState([]);
    const [newProductsFromAddons, setNewProductsFromAddons] = useState([]);
    const [allAddonList, setAllAddonList] = useState([]);
    const [filteredAddonValues, setFilteredAddonValues] = useState([]);
    const [selectedAddonGroups, setSelectedAddonGroups] = useState([]);
    const [selectedAddonValues, setSelectedAddonValues] = useState([]);
    const [statusFilter, setStatusFilter] = useState('ALL');
    const [dateFilter, setDateFilter] = useState('ALL');
    const [fetchLoading, setFetchLoading] = useState(false);

    const formattedDate = (string) => {
        return string?.split("T")[0];
    }

    // Add this function to handle addon group selection
    const handleSelectAllAddonChange = (type, selectedOptions) => {
        if (type === 'excludedAddonGroups') {
            setSelectedAddonGroups(selectedOptions || []);

            if (selectedOptions && selectedOptions.length > 0) {
                const selectedGroupIds = selectedOptions.map(option => option.value);
                const valuesFromSelectedGroups = allAddonList
                    .filter(addon => selectedGroupIds.includes(addon._id))
                    .flatMap(addon =>
                        addon.addonValues.map(value => ({
                            value: {
                                addonId: addon._id,
                                addonValueId: value._id,
                                addonTitle: addon.title,
                                addonValueTitle: value.value
                            },
                            label: `${addon.title} - ${value.value}`
                        }))
                    );
                setFilteredAddonValues(valuesFromSelectedGroups);
            } else {
                setFilteredAddonValues([]);
                setSelectedAddonValues([]);
            }
        }
    };

    // Add this function to handle addon value selection
    const handleAddonValueChange = (selectedOptions) => {
        setSelectedAddonValues(selectedOptions || []);

        const excludedAddons = selectedOptions ? selectedOptions.map(option => option.value) : [];
        setCouponData(prev => ({
            ...prev,
            excludedAddons: excludedAddons
        }));
    };

    const columns = [
        {
            header: "Sr.No",
            accessor: "serialNumber",
            render: (value) => (
                <span style={{ fontSize: "12px", fontWeight: "500" }}>
                    {value}
                </span>
            )
        },

        {
            header: "Coupon Title",
            accessor: "name",
            render: (value, row) => (
                <div className="d-flex align-items-center" style={{ fontSize: "12px" }}>
                    <i
                        className="ri-coupon-line me-1 text-primary"
                        style={{ fontSize: "14px" }}
                    ></i>
                    <span style={{ fontWeight: "500" }}>
                        {row?.coupon?.title || "N/A"}
                    </span>
                </div>
            ),
        },

        {
            header: "Coupon Code",
            accessor: "code",
            render: (value, row) => (
                <Badge
                    bg="info"
                    style={{
                        fontSize: "11px",
                        padding: "3px 6px",
                        fontWeight: "500"
                    }}
                >
                    <i
                        className="ri-tag-line me-1"
                        style={{ fontSize: "12px" }}
                    ></i>
                    {row?.coupon?.couponCode || "N/A"}
                </Badge>
            )
        },

        {
            header: "User Details",
            accessor: "userDetails",
            render: (value, row) => (
                <div>
                    <div className="d-flex align-items-center" style={{ fontSize: "12px" }}>
                        <i
                            className="ri-user-line me-1 text-primary"
                            style={{ fontSize: "14px" }}
                        ></i>
                        <span style={{ fontWeight: "500" }}>
                            {row?.userDetails?.name || "N/A"}
                        </span>
                       
                    </div>
                    <div style={{ fontSize: "11px" }}>
                        <span className='text-muted'>
                            {row?.userDetails?.mobile || "N/A"}
                        </span>
                        <br />
                        <span className='text-muted'>
                            {row?.userDetails?.email || "N/A"}
                        </span>
                    </div>
                </div>
            ),
        },

        {
            header: "Usage Type",
            accessor: "usageType",
            render: (value, row) => (
                <span
                    className={
                        row?.coupon?.usageType === "MULTIPLE"
                            ? "text-primary"
                            : "text-secondary"
                    }
                    style={{
                        fontSize: "11px",
                        fontWeight: "500"
                    }}
                >
                    <i
                        className="ri-repeat-line me-1"
                        style={{ fontSize: "12px" }}
                    ></i>
                    {row?.coupon?.usageType || "N/A"}
                </span>
            ),
        },

        {
            header: "Status",
            accessor: "status",
            render: (value, row) => {
                const isActive =
                    checkCouponActive(row) &&
                    row?.coupon?.status === "ACTIVE";

                return (
                    <span
                        className={
                            isActive ? "text-success" : "text-danger"
                        }
                        style={{
                            fontSize: "11px",
                            fontWeight: "600"
                        }}
                    >
                        <i
                            className={
                                isActive
                                    ? "ri-checkbox-circle-line me-1"
                                    : "ri-close-circle-line me-1"
                            }
                            style={{ fontSize: "12px" }}
                        ></i>

                        {isActive ? "ACTIVE" : "INACTIVE"}
                    </span>
                );
            },
        },

        {
            header: "Valid From",
            accessor: "validFrom",
            render: (value, row) => (
                <div
                    className="d-flex align-items-center"
                    style={{ fontSize: "11px" }}
                >
                    <i
                        className="ri-calendar-event-line me-1 text-muted"
                        style={{ fontSize: "12px" }}
                    ></i>

                    <span>
                        {row?.coupon?.validityStartDate
                            ? format(
                                new Date(row?.coupon?.validityStartDate),
                                "dd MMM yyyy"
                            )
                            : (
                                <span style={{ color: "#6c757d" }}>
                                    --------
                                </span>
                            )}
                    </span>
                </div>
            ),
        },

        {
            header: "Valid Till",
            accessor: "validTill",
            render: (value, row) => (
                <div
                    className="d-flex align-items-center"
                    style={{ fontSize: "11px" }}
                >
                    <i
                        className="ri-calendar-close-line me-1 text-muted"
                        style={{ fontSize: "12px" }}
                    ></i>

                    <span>
                        {row?.coupon?.validityEndDate
                            ? format(
                                new Date(row?.coupon?.validityEndDate),
                                "dd MMM yyyy"
                            )
                            : (
                                <span style={{ color: "#6c757d" }}>
                                    --------
                                </span>
                            )}
                    </span>
                </div>
            ),
        },

        {
            header: "Actions",
            accessor: null,
            render: (_, row) => (
                <Dropdown>
                    <Dropdown.Toggle
                        variant="light"
                        size="sm"
                        style={{
                            padding: "2px 6px",
                            fontSize: "12px",
                            border: "none",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                        }}
                    >
                        <i
                            className="ri-more-2-fill"
                            style={{ fontSize: "14px" }}
                        ></i>
                    </Dropdown.Toggle>

                    <Dropdown.Menu align="end" style={{ fontSize: "12px" }}>

                        {(couponAccess.includes("UserCouponAllocation:update") ||
                            email === "contact@xpansecafe.com") && (
                                <Dropdown.Item
                                    className="text-primary"
                                    style={{ fontSize: "12px" }}
                                    onClick={() =>
                                        handleOpenEditModal(row)
                                    }
                                >
                                    <i className="ri-edit-line me-1"></i>
                                    Edit
                                </Dropdown.Item>
                            )}

                        {(couponAccess.includes("UserCouponAllocation:get") ||
                            email === "contact@xpansecafe.com") && (
                                <Dropdown.Item
                                    className="text-success"
                                    style={{ fontSize: "12px" }}
                                    onClick={() =>
                                        handleOpenViewModal(row)
                                    }
                                >
                                    <i className="ri-eye-line me-1"></i>
                                    View
                                </Dropdown.Item>
                            )}

                        {(couponAccess.includes("UserCouponAllocation:delete") ||
                            email === "contact@xpansecafe.com") && (
                                <Dropdown.Item
                                    className="text-danger"
                                    style={{ fontSize: "12px" }}
                                    onClick={() =>
                                        handleDeleteModal(row)
                                    }
                                >
                                    <i className="ri-delete-bin-line me-1"></i>
                                    Delete
                                </Dropdown.Item>
                            )}

                    </Dropdown.Menu>
                </Dropdown>
            ),
        },
    ];


    const checkCouponActive = (coupon) => {
        console.log("Coupon Details", coupon);
        
        if (!coupon) return false;
        const today = new Date();
        const endDate = coupon?.coupon?.validityEndDate ? parseISO(coupon?.coupon?.validityEndDate) : null;
        if (!endDate) return false;
        return isBefore(today, endDate) || format(today, 'yyyy-MM-dd') === format(endDate, 'yyyy-MM-dd');
    };

    const isSameDay = (date1, date2) => {
        return format(date1, 'yyyy-MM-dd') === format(date2, 'yyyy-MM-dd');
    };

    const applyFilters = (data) => {
        let filtered = [...data];
        const today = new Date();

        if (statusFilter !== 'ALL') {
            filtered = filtered.filter(item => {
                const isActive = checkCouponActive(item);
                return statusFilter === 'ACTIVE' ? isActive : !isActive;
            });
        }

        if (dateFilter !== 'ALL') {
            filtered = filtered.filter(item => {
                const startDate = item?.coupon?.validityStartDate ? parseISO(item?.coupon?.validityStartDate) : null;
                const endDate = item?.coupon?.validityEndDate ? parseISO(item?.coupon?.validityEndDate) : null;

                if (!startDate || !endDate) return false;

                switch (dateFilter) {
                    case 'EXPIRED':
                        return isAfter(today, endDate);
                    case 'UPCOMING':
                        return isAfter(startDate, today);
                    case 'CURRENT':
                        return (isBefore(today, endDate) || isSameDay(today, endDate)) &&
                            (isAfter(today, startDate) || isSameDay(today, startDate));
                    default:
                        return true;
                }
            });
        }

        if (searchText.trim() !== '') {
            const query = searchText.toLowerCase();
            filtered = filtered.filter((item) => {
                return (
                    item?.coupon?.couponCode?.toLowerCase().includes(query) ||
                    item?.coupon?.title?.toLowerCase().includes(query) ||
                    item?.coupon?.usageType?.toLowerCase().includes(query) ||
                    item?.coupon?.userDetails?.name?.toLowerCase().includes(query) ||
                    item?.coupon?.userDetails?.email?.toLowerCase().includes(query)
                );
            });
        }

        return filtered;
    };

    const addTerm = () => {
        if (!currentTerm.trim()) return;
        setCouponData((prevData) => ({
            ...prevData,
            termsAndConditions: Array.isArray(prevData.termsAndConditions)
                ? [...prevData.termsAndConditions, currentTerm]
                : [currentTerm],
        }));
        setCurrentTerm('');
    };

    const removeTerm = (index) => {
        setCouponData((prevData) => ({
            ...prevData,
            termsAndConditions: Array.isArray(prevData.termsAndConditions)
                ? prevData.termsAndConditions.filter((_, i) => i !== index)
                : [],
        }));
    };

    const usersInfo = usersList.map((user) => ({
        value: user?._id,
        label: `${user?.name} (${user?.mobile})`
    }));

    const freebieProductsOptions = productsList
        .filter(product => product.isFreebieProduct === true)
        .map((product) => ({
            value: product?._id,
            label: `${product?.name}`
        }));

    const productsInfo = productsList
        .filter(product => product?.isFreebieProduct === false)
        .map(product => ({
            value: product?._id,
            label: product?.name
        }));

    const exProductsInfo = exProductList
        .filter(product => product?.isFreebieProduct === false)
        .map(product => ({
            value: product?._id,
            label: product?.name
        }));

    const categoriesData = categoryList.map((category) => ({
        value: category._id,
        label: `${category.name}`
    }));

    const outletData = outlets
        .filter(
            (outlet) =>
                !selections.selectedExcludedOutlets?.some((selected) => selected.value === outlet._id) &&
                !selections.selectedIncludedOutlets?.some((selected) => selected.value === outlet._id)
        )
        .map((outlet) => ({
            value: outlet._id,
            label: `${outlet.name} (${outlet.city})`,
        }));

    const editOutletData = outlets
        .filter((outlet) => {
            const isExcluded = editSelections?.selectedExcludedOutlets?.some(
                (excludedOutlet) => excludedOutlet.value === outlet._id
            );
            const isIncluded = editSelections?.selectedIncludedOutlets?.some(
                (includedOutlet) => includedOutlet.value === outlet._id
            );
            return !isExcluded && !isIncluded;
        })
        .map((outlet) => ({
            value: outlet._id,
            label: `${outlet.name} (${outlet.city})`,
        }));

    const levelsData = levels.map((level) => ({
        value: level._id,
        label: `${level.sequenceNo}. ${level.title}`
    }));

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            width: "100%",
            borderRadius: '6px',
            borderColor: state.isFocused ? "#2684ff" : "#ced4da",
            boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(38,132,255,.25)" : null,
            "&:hover": {
                borderColor: state.isFocused ? "#2684ff" : "#ced4da",
            },
            minHeight: '38px',
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "#6c757d"
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999
        })
    };

    const checkboxes = [
        { id: "isBogoCoupon", label: "Bogo Coupon", field: "isBogoCoupon", icon: "ri-shopping-basket-fill" },
        { id: "isUniversalCoupon", label: "universal Coupon", field: "isUniversalCoupon", icon: "ri-global-line" },
        { id: "isSizeUpgradeCoupon", label: "Size Upgrade", field: "isSizeUpgradeCoupon", icon: "ri-arrow-up-line" },
        { id: "isComboCategoryCoupon", label: "Combo Coupon", field: "isComboCategoryCoupon", icon: "ri-links-line" },
        { id: "isMRPCoupon", label: "MRP Coupon", field: "isMrpDiscount", icon: "ri-price-tag-3-line" },
        { id: "isFreebieCoupon", label: "Freebie Coupon", field: "isFreebieCoupon", icon: "ri-gift-line" },
    ];

    const handleCheckboxChange = (field) => (e) => {
        const currentUsers = selectedUsers;
        resetFields();
        setSelectedUsers(currentUsers);
        setUniversalCoupon(field === "isUniversalCoupon" ? e.target.checked : false)
        setCouponData((prev) => ({
            ...prev,
            [field]: e.target.checked,
            isBogoCoupon: field === "isBogoCoupon" ? e.target.checked : false,
            isSizeUpgradeCoupon: field === "isSizeUpgradeCoupon" ? e.target.checked : false,
            isComboCategoryCoupon: field === "isComboCategoryCoupon" ? e.target.checked : false,
            isMrpDiscount: field === "isMrpDiscount" ? e.target.checked : false,
            isFreebieCoupon: field === "isFreebieCoupon" ? e.target.checked : false,
        }));
    };

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
    };

    const resetFields = () => {
        setCouponData({
            isBogoCoupon: false,
            isSizeUpgradeCoupon: false,
            isFreebieCoupon: false,
            freebieProduct: "",
            freebieQuantity: "",
            sizeUpgradeAddon: "",
            title: "",
            description: "",
            usageType: "",
            orderType: "ALL",
            couponCode: "",
            discountPercent: "",
            dayOfWeek: "",
            discountAmount: "",
            validityStartDate: "",
            validityEndDate: "",
            startTime: "",
            endTime: "",
            discountPrice: "",
            applicableQuantityType: "",
            applicableProducts: [],
            termsAndConditions: [],
            isComboCategoryCoupon: false,
            maxAddonsAllowed: null,
            maxDiscountAmount: "",
            minOrderAmount: "",
            isMrpDiscount: false,
            excludedAddons: [],
            isHidden: "false"
        });

        setSelections({
            selectedIncludedOutlets: [],
            selectedExcludedOutlets: [],
            selectedApplicableCategories: [],
            selectedApplicableProducts: [],
            selectedDependentCategories: [],
            selectedDependentProducts: [],
            selectedExcludedProducts: [],
            selectedApplicableLevels: [],
            primaryComboCategories: [],
            secondaryComboCategories: []
        });

        setFile(null);
        setFromDate(null);
        setToDate(null);
        setSelectedCategories([]);
        setSelectedProducts([]);
        setSelectedUsers([]);
        setSelectedAddonGroups([]);
        setSelectedAddonValues([]);
        setFilteredAddonValues([]);
    }

    const handleDeleteModal = async (data) => {
        setOpenDeleteModal(true);
        setUserCouponAllocationId(data?.userCouponAllocationId);
    };

    const handleDeleteUserCouponAllocation = async (e) => {
        e.preventDefault();
        setIsDeleteBtnLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            const data = {
                _id: userCouponAllocationId,
            };
            const response = await axiosInstance.delete(`user-coupon-allocation`, { data, headers });

            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message || "Coupon allocation deleted successfully!", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                setOpenDeleteModal(false);
                fetchData();
            }
        } catch (error) {
            console.log(error.response);
            if (error.response?.status === 403) {
                toast.error(error?.response?.data?.data?.message || "Permission denied", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            } else {
                let errorMessage = error.response?.data?.error || "Failed to delete coupon allocation";
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        } finally {
            setIsDeleteBtnLoading(false);
        }
    };

    const handleCloseDeleteModal = () => {
        setOpenDeleteModal(false);
    };

    const handleAddNewOpenModal = () => {
        setAddNewOpenModal(true);
        resetFields();
    };

    const handleCloseAddNewOpenModal = () => {
        setAddNewOpenModal(false);
        resetFields();
    };

    const handleInputChange = (e) => {
        const { name, value, type } = e.target;
        const updatedCouponCode = name === "couponCode" ? value.toUpperCase() : value;
        setCouponData((prev) => {
            const updatedData = {
                ...prev,
                [name]: type === "number" ? parseFloat(value) || "" : updatedCouponCode,
            };
            return updatedData;
        });
    };

    const handleSelectUsersChange = (users) => {
        setSelectedUsers(users);
    };

    const handleSelectCategoryChange = (cats) => {
        setSelectedCategories(cats);
    };

    const handleSelectProductChange = (products) => {
        setSelectedProducts(products);
    };

    const handleFromDateChange = (date) => {
        if (date) {
            setFromDate(date);
            // Auto-set end date to start date + 30 days if not set
            // if (!toDate) {
            //     setToDate(addDays(date, 30));
            // }
        }
    };

    const handleToDateChange = (date) => {
        if (date) {
            setToDate(date);
        }
    };

    const getAddonList = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axiosInstance.get("addons?page=1&limit=100", { headers });
            if (response?.data?.status === true) {
                setAllAddonList(response?.data?.data?.addons || []);
            }
        } catch (error) {
            toast.error(error?.response?.data?.error || "Failed to fetch addons", {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
        }
    };

    const getUsersList = async (query) => {
        if (!query) {
            setUsersList([]);
            return;
        }
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axiosInstance.get(`user?search=${query}`, { headers });
            if (response?.data?.status === true) {
                const users = response?.data?.data?.users || [];
                setUsersList(users);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        }
    };

    const debouncedGetUsersList = debounce(getUsersList, 500);

    const getProductsList = async (catId) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axiosInstance.get("product", { headers });
            if (response?.data?.status === true) {
                const products = response?.data?.data?.products || [];
                setProductsList(products);

                if (catId && catId.length > 0) {
                    let excludedProducts = products.filter((fi) =>
                        catId.some((category) => category.value === fi?.category?._id)
                    );
                    // setExProductList(excludedProducts);
                    setExProductList(products);
                } else {
                    setExProductList(products);
                }
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        }
    };

    const getCategoryList = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axiosInstance.get("masters/category/get", { headers });

            if (response?.data?.status === true) {
                setCategoryList(response?.data?.data?.categories || []);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        }
    };

    const handleSubmitCoupon = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            let selectedUsersData;
            if (selectedUsers.length > 0) {
                selectedUsersData = selectedUsers.map((c) => c.value);
            } else {
                selectedUsersData = usersFromFile;
            }

            if (selectedUsersData?.length === 0) {
                toast.error("Please select at least one user", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                setIsLoading(false);
                return;
            }

            if (!couponData.title || !couponData.title.trim()) {
                toast.error("Title is required", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                setIsLoading(false);
                return;
            }

            if (!couponData.couponCode || !couponData.couponCode.trim()) {
                toast.error("Coupon Code is required", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                setIsLoading(false);
                return;
            }

            if (!couponData.validityStartDate || !couponData.validityEndDate) {
                toast.error("Please provide both start and end dates", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                setIsLoading(false);
                return;
            }

            if (couponData.isFreebieCoupon) {
                if (!couponData.freebieProduct) {
                    toast.error("Please select a freebie product", {
                        position: "top-right",
                        autoClose: 3000,
                        theme: "light",
                    });
                    setIsLoading(false);
                    return;
                }
                if (!couponData.freebieQuantity || couponData.freebieQuantity <= 0) {
                    toast.error("Please enter a valid freebie quantity", {
                        position: "top-right",
                        autoClose: 3000,
                        theme: "light",
                    });
                    setIsLoading(false);
                    return;
                }
            }

            // Validate discount fields
            if (!couponData.isFreebieCoupon && !couponData.isBogoCoupon && !couponData.isSizeUpgradeCoupon) {
                const hasDiscount = couponData.discountPercent || couponData.discountAmount || couponData.discountPrice;
                if (!hasDiscount) {
                    toast.error("Please enter discount amount, percentage, or price", {
                        position: "top-right",
                        autoClose: 3000,
                        theme: "light",
                    });
                    setIsLoading(false);
                    return;
                }
            }

            const selectedIncludedOutlets = selections?.selectedIncludedOutlets?.map((option) => option.value) || [];
            const selectedExcludedOutlets = selections?.selectedExcludedOutlets?.map((option) => option.value) || [];
            const selectedApplicableCategories = selections?.selectedApplicableCategories?.map((option) => option.value) || [];
            const selectedApplicableProducts = selections?.selectedApplicableProducts?.map((option) => option.value) || [];
            const selectedApplicableLevels = selections?.selectedApplicableLevels?.map((option) => option.value) || [];
            const selectedDependentCategories = selections?.selectedDependentCategories?.map((option) => option.value) || [];
            const selectedDependentProducts = selections?.selectedDependentProducts?.map((option) => option.value) || [];
            const selectedExcludedProducts = selections?.selectedExcludedProducts?.map((option) => option.value) || [];
            const selectedPrimaryComboCategories = selections?.primaryComboCategories?.map((option) => option.value) || [];
            const selectedSecondaryComboCategories = selections?.secondaryComboCategories?.map((option) => option.value) || [];

            let updatedCouponData = {
                ...couponData,
                isCouponAllocated: true,
                excludedOutlets: selectedExcludedOutlets,
                includedOutlets: selectedIncludedOutlets,
                applicableLevels: selectedApplicableLevels,
            };

            // Add selected arrays if they have values
            if (selectedPrimaryComboCategories.length > 0) updatedCouponData.primaryComboCategories = selectedPrimaryComboCategories;
            if (selectedSecondaryComboCategories.length > 0) updatedCouponData.secondaryComboCategories = selectedSecondaryComboCategories;
            if (selectedDependentCategories.length > 0) updatedCouponData.dependantCategories = selectedDependentCategories;
            if (selectedDependentProducts.length > 0) updatedCouponData.dependantProducts = selectedDependentProducts;
            if (selectedExcludedProducts.length > 0) updatedCouponData.excludedProductList = selectedExcludedProducts;
            if (selectedApplicableProducts.length > 0) updatedCouponData.applicableProducts = selectedApplicableProducts;
            if (selectedApplicableCategories.length > 0) updatedCouponData.applicableCategories = selectedApplicableCategories;

            // Clean up empty arrays
            Object.keys(updatedCouponData).forEach((key) => {
                if (Array.isArray(updatedCouponData[key]) && updatedCouponData[key].length === 0) {
                    delete updatedCouponData[key];
                }
            });

            // For freebie coupons, clear discount fields
            if (couponData.isFreebieCoupon) {
                delete updatedCouponData.discountPercent;
                delete updatedCouponData.discountAmount;
                delete updatedCouponData.maxDiscountAmount;
                delete updatedCouponData.discountPrice;
                delete updatedCouponData.isMrpDiscount;
                delete updatedCouponData.applicableQuantityType;
                delete updatedCouponData.isBogoCoupon;
                delete updatedCouponData.isSizeUpgradeCoupon;
                delete updatedCouponData.isComboCategoryCoupon;
            }

            // Conditional field cleanup
            if (updatedCouponData?.discountAmount) {
                delete updatedCouponData.discountPercent;
                delete updatedCouponData.applicableProducts;
                delete updatedCouponData.isSizeUpgradeCoupon;
                delete updatedCouponData.sizeUpgradeAddon;
                delete updatedCouponData.applicableQuantityType;
            }

            if (updatedCouponData?.discountPercent) {
                delete updatedCouponData.discountAmount;
                delete updatedCouponData.applicableProducts;
                delete updatedCouponData.isSizeUpgradeCoupon;
                delete updatedCouponData.sizeUpgradeAddon;
                delete updatedCouponData.applicableQuantityType;
            }

            if (updatedCouponData.isBogoCoupon) {
                delete updatedCouponData.applicableProducts;
                delete updatedCouponData.discountPercent;
                delete updatedCouponData.discountAmount;
                delete updatedCouponData.discountPrice;
                delete updatedCouponData.applicableQuantityType;
                delete updatedCouponData.isSizeUpgradeCoupon;
                delete updatedCouponData.sizeUpgradeAddon;
            }

            if (updatedCouponData.isSizeUpgradeCoupon) {
                delete updatedCouponData.discountPercent;
                delete updatedCouponData.discountAmount;
                delete updatedCouponData.discountPrice;
                delete updatedCouponData.applicableQuantityType;
            }

            // Remove empty, null, or undefined values
            let newCouponData = Object.fromEntries(
                Object.entries(updatedCouponData).filter(
                    ([_, value]) => value !== null && value !== undefined && value !== ""
                )
            );

            // Handle API Call
            const response = await axiosInstance.post("coupons", newCouponData, { headers });

            if (response?.data?.status === true) {
                const couponId = response?.data?.data?.dbResponse?._id;
                await handleSubmitUserCoupon(couponId);
                resetFields();
            }
        } catch (error) {
            let errorMessage = 'An error occurred while creating coupon';
            console.log(error.response);

            if (error?.response) {
                if (error.response?.status === 406) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error || error?.response?.data?.data?.title;
                } else if (error.response?.status === 412 || error?.response?.status === 404) {
                    errorMessage = error?.response?.data?.data?.title;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }
            }
            toast.error(errorMessage, {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
        } finally {
            setIsLoading(false);
        }
    };

    const handleSubmitUserCoupon = async (couponId) => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            let selectedUsersData;
            if (selectedUsers.length > 0) {
                selectedUsersData = selectedUsers.map((c) => c.value);
            } else {
                selectedUsersData = usersFromFile;
            }

            if (selectedUsersData?.length === 0) {
                toast.error("Users Required", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                return;
            }

            const data = {
                users: selectedUsersData,
                coupon_id: couponId
            };

            const response = await axiosInstance.post("user-coupon-allocation", data, {
                headers,
            });

            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message || "Coupon allocated successfully!", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
                fetchData();
                handleCloseAddNewOpenModal();
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = '';
                if (error.response?.status === 406) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
                }
                else if (error.response?.status === 412 || error?.response?.status === 404) {
                    errorMessage = error?.response?.data?.data?.title;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        }
    };

    const fetchData = async () => {
        try {
            setFetchLoading(true);
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };

            // Add pagination parameters to API call
            const response = await axiosInstance.get(
                `user-coupon-allocation?page=${pagination.page}&limit=${pagination.rowsPerPage}`,
                { headers }
            );
            console.log("Response of Get User Coupon Api :", response);

            if (response?.data?.status === true) {
                const data = response?.data?.data || {};
                console.log("Logging Data in If Statement :", data);

                const coupons = data?.userCouponAllocationData || [];
                console.log("Coupons :", coupons);
                const sortedData = [...coupons].sort((a, b) => {
                    return new Date(b.coupon.createdAt) - new Date(a.coupon.createdAt);
                });
                const totalRecords = data?.pagination?.totalRecords;
                const totalPages = data?.pagination?.totalPages;

                // Update pagination state
                setPagination(prev => ({
                    ...prev,
                    totalRecords,
                    totalPages
                }));

                // Add serial numbers
                const numberedData = sortedData?.map((item, index) => ({
                    ...item,
                    serialNumber: (pagination.page - 1) * pagination.rowsPerPage + index + 1,
                }));

                console.log("Numbered Data response :", numberedData);


                setUserCouponAllocationData(numberedData);

                // Apply filters
                const filtered = applyFilters(numberedData);
                setFilteredData(filtered);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        } finally {
            setFetchLoading(false);
        }
    };

    const getOutlets = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axiosInstance.get("outlet", { headers });

            if (response?.data?.status === true) {
                setOutlets(response?.data?.data?.outlets || []);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        }
    };

    const getLevels = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axiosInstance.get("level", { headers });
            if (response?.data?.status === true) {
                const levels = response?.data?.data?.levels || [];
                setLevels(levels);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        }
    };

    const handleOpenViewModal = (data) => {
        setOpenViewModal(true);
        setCouponUsers(data?.userDetails || {});
        setCouponDetails(data?.coupon);
    };

    const handleOpenEditModal = (data) => {
        setUpdatingData(data);
        setOpenEditModal(true);
    };

    const getAddonProductsList = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axiosInstance.get("product-addon?limit=1000&page=1", { headers });
            if (response?.data?.status === true) {
                const addOns = response?.data?.data?.productAddons || [];
                const productsWithSizeAddon = addOns.filter((item) =>
                    item.addons.some((addon) => addon.addonTitle.toLowerCase() === 'size')
                );
                setAddonList(productsWithSizeAddon);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        }
    };

    const handleFileUpload = (file) => {
        if (!file) {
            toast.warning("Please select a file", {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
            return;
        }

        const allowedFileTypes = [
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ];
        const maxSizeInMB = 5;

        if (!allowedFileTypes.includes(file.type)) {
            toast.error("Please upload a valid Excel file (.xls or .xlsx)", {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
            return;
        }

        if (file.size > maxSizeInMB * 1024 * 1024) {
            toast.error(`File size should not exceed ${maxSizeInMB} MB`, {
                position: "top-right",
                autoClose: 3000,
                theme: "light",
            });
            return;
        }
        setFile(file);
        parseExcelFile(file);
    };

    const parseExcelFile = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            try {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: "array" });
                const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

                const userIds = rows
                    .filter((row, index) => index !== 0 && row[5] && row[5] !== "ID")
                    .map(row => row[5])
                    .filter(id => id);

                setUsersFromFile(userIds);

                if (userIds.length > 0) {
                    toast.success(`Loaded ${userIds.length} users from file`, {
                        position: "top-right",
                        autoClose: 3000,
                        theme: "light",
                    });
                } else {
                    toast.warning("No valid user IDs found in the file", {
                        position: "top-right",
                        autoClose: 3000,
                        theme: "light",
                    });
                }
            } catch (error) {
                toast.error("Error reading Excel file", {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        };
        reader.readAsArrayBuffer(file);
    };

    const handlePageChange = (page) => {
        setPagination(prev => ({ ...prev, page }));
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        setPagination({ page: 1, rowsPerPage, totalRecords: 0, totalPages: 0 });
    };

    const getDayOfWeek = (index) => {
        const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        return days[index] || "Invalid day";
    };

    const getPaginatedData = () => {
        return filteredData;
    };

    const handleChange = (key, value) => {
        setSelections((prev) => ({
            ...prev,
            [key]: value,
        }));

        if (key === "selectedApplicableCategories") {
            getProductsList(value);
        }
    };

    const getNewSizeAddons = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            };
            const response = await axiosInstance.get('/product/getSizeUpgradeAddonsWithProducts', { headers });
            setNewSizeAddonsList(response?.data?.data?.addons || []);
            let newproducts = response?.data?.data?.addons?.flatMap((add) => add?.products || []) || [];
            setNewProductsFromAddons(newproducts);
        } catch (error) {
            console.log("Error fetching size addons:", error);
        }
    };

    const handleStatusFilterChange = (status) => {
        setStatusFilter(status);
        setPagination(prev => ({ ...prev, page: 1 }));
    };

    const handleDateFilterChange = (dateType) => {
        setDateFilter(dateType);
        setPagination(prev => ({ ...prev, page: 1 }));
    };

    // Apply filters whenever filter states change
    useEffect(() => {
        if (userCouponAllocationData.length > 0) {
            const filtered = applyFilters(userCouponAllocationData);
            setFilteredData(filtered);
        }
    }, [statusFilter, dateFilter, searchText, userCouponAllocationData]);

    // Fetch data when pagination changes
    useEffect(() => {
        fetchData();
    }, [pagination.page, pagination.rowsPerPage]);

    useEffect(() => {
        const formattedStartDate = fromDate ? format(fromDate, "yyyy-MM-dd") : "";
        const formattedEndDate = toDate ? format(toDate, "yyyy-MM-dd") : "";

        setCouponData((prev) => ({
            ...prev,
            validityStartDate: formattedStartDate,
            validityEndDate: formattedEndDate,
        }));
    }, [fromDate, toDate]);

    // Initialize on component mount
    useEffect(() => {
        getUsersList();
        getProductsList();
        getCategoryList();
        getAddonProductsList();
        getOutlets();
        getLevels();
        getNewSizeAddons();
        getAddonList();
    }, []);

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-3">
                <div className="container-fluid">
                    <div className="card border-0 shadow-sm">
                        <div className="card-header bg-white border-0 py-3">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h5 className="fw-bold mb-0">
                                        <i className="ri-coupon-line me-2 text-primary"></i>
                                        USER COUPON ALLOCATION
                                    </h5>
                                    <small className="text-muted">Manage coupon allocations for users</small>
                                </div>
                                <div className="col-auto">
                                    {(couponAccess.includes("UserCouponAllocation:add") || email === "contact@xpansecafe.com") && (
                                        <Button
                                            variant="primary"
                                            className="fw-semibold px-4 py-2"
                                            onClick={handleAddNewOpenModal}
                                        >
                                            <i className="ri-add-line me-2"></i>
                                            Allocate New Coupon
                                        </Button>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="card-body">
                            {/* Filters Section */}
                            <div className="row mb-4 g-3">
                                <div className="col-md-3">
                                    <div className="card border">
                                        <div className="card-body py-2">
                                            <h6 className="mb-2">
                                                <i className="ri-filter-line me-2 text-muted"></i>
                                                Status
                                            </h6>
                                            <div className="btn-group w-100" role="group">
                                                <Button
                                                    variant={statusFilter === 'ALL' ? 'primary' : 'outline-secondary'}
                                                    size="sm"
                                                    onClick={() => handleStatusFilterChange('ALL')}
                                                    className="flex-fill"
                                                >
                                                    All
                                                </Button>
                                                <Button
                                                    variant={statusFilter === 'ACTIVE' ? 'success' : 'outline-secondary'}
                                                    size="sm"
                                                    onClick={() => handleStatusFilterChange('ACTIVE')}
                                                    className="flex-fill"
                                                >
                                                    Active
                                                </Button>
                                                <Button
                                                    variant={statusFilter === 'INACTIVE' ? 'danger' : 'outline-secondary'}
                                                    size="sm"
                                                    onClick={() => handleStatusFilterChange('INACTIVE')}
                                                    className="flex-fill"
                                                >
                                                    Inactive
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="card border">
                                        <div className="card-body py-2">
                                            <h6 className="mb-2">
                                                <i className="ri-calendar-line me-2 text-muted"></i>
                                                Date Filter
                                            </h6>
                                            <div className="btn-group w-100" role="group">
                                                <Button
                                                    variant={dateFilter === 'ALL' ? 'primary' : 'outline-secondary'}
                                                    size="sm"
                                                    onClick={() => handleDateFilterChange('ALL')}
                                                    className="flex-fill"
                                                >
                                                    All
                                                </Button>
                                                <Button
                                                    variant={dateFilter === 'CURRENT' ? 'info' : 'outline-secondary'}
                                                    size="sm"
                                                    onClick={() => handleDateFilterChange('CURRENT')}
                                                    className="flex-fill"
                                                >
                                                    Current
                                                </Button>
                                                <Button
                                                    variant={dateFilter === 'UPCOMING' ? 'warning' : 'outline-secondary'}
                                                    size="sm"
                                                    onClick={() => handleDateFilterChange('UPCOMING')}
                                                    className="flex-fill"
                                                >
                                                    Upcoming
                                                </Button>
                                                <Button
                                                    variant={dateFilter === 'EXPIRED' ? 'danger' : 'outline-secondary'}
                                                    size="sm"
                                                    onClick={() => handleDateFilterChange('EXPIRED')}
                                                    className="flex-fill"
                                                >
                                                    Expired
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-5">
                                    <div className="card border">
                                        <div className="card-body py-2">
                                            <h6 className="mb-2">
                                                <i className="ri-search-line me-2 text-muted"></i>
                                                Search
                                            </h6>
                                            <div className="input-group">
                                                <span className="input-group-text bg-white border-end-0">
                                                    <i className="ri-search-line text-muted"></i>
                                                </span>
                                                <input
                                                    type="text"
                                                    value={searchText}
                                                    onChange={handleSearchChange}
                                                    className="form-control border-start-0"
                                                    placeholder="Search coupons, users, or codes..."
                                                />
                                                {searchText && (
                                                    <button
                                                        className="btn btn-outline-secondary"
                                                        type="button"
                                                        onClick={() => setSearchText('')}
                                                    >
                                                        <i className="ri-close-line"></i>
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Stats Overview */}
                            {/* <div className="row mb-4">
                                <div className="col-md-3">
                                    <div className="card border-0 bg-primary bg-opacity-10">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center">
                                                <div className="flex-shrink-0">
                                                    <div className="bg-primary text-white rounded-circle p-3">
                                                        <i className="ri-coupon-3-line fs-4"></i>
                                                    </div>
                                                </div>
                                                <div className="flex-grow-1 ms-3">
                                                    <h5 className="mb-0 fw-bold">{userCouponAllocationData.length}</h5>
                                                    <span className="text-muted">Total Allocations</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="card border-0 bg-success bg-opacity-10">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center">
                                                <div className="flex-shrink-0">
                                                    <div className="bg-success text-white rounded-circle p-3">
                                                        <i className="ri-checkbox-circle-line fs-4"></i>
                                                    </div>
                                                </div>
                                                <div className="flex-grow-1 ms-3">
                                                    <h5 className="mb-0 fw-bold">
                                                        {userCouponAllocationData.filter(item => checkCouponActive(item) && item?.status === "ACTIVE").length}
                                                    </h5>
                                                    <span className="text-muted">Active</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="card border-0 bg-warning bg-opacity-10">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center">
                                                <div className="flex-shrink-0">
                                                    <div className="bg-warning text-white rounded-circle p-3">
                                                        <i className="ri-time-line fs-4"></i>
                                                    </div>
                                                </div>
                                                <div className="flex-grow-1 ms-3">
                                                    <h5 className="mb-0 fw-bold">
                                                        {userCouponAllocationData.filter(item => {
                                                            const startDate = item?.validityStartDate ? parseISO(item.validityStartDate) : null;
                                                            const today = new Date();
                                                            return startDate && isAfter(startDate, today);
                                                        }).length}
                                                    </h5>
                                                    <span className="text-muted">Upcoming</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="card border-0 bg-danger bg-opacity-10">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center">
                                                <div className="flex-shrink-0">
                                                    <div className="bg-danger text-white rounded-circle p-3">
                                                        <i className="ri-close-circle-line fs-4"></i>
                                                    </div>
                                                </div>
                                                <div className="flex-grow-1 ms-3">
                                                    <h5 className="mb-0 fw-bold">
                                                        {userCouponAllocationData.filter(item => {
                                                            const endDate = item?.validityEndDate ? parseISO(item.validityEndDate) : null;
                                                            const today = new Date();
                                                            return endDate && isAfter(today, endDate);
                                                        }).length}
                                                    </h5>
                                                    <span className="text-muted">Expired</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}

                            {/* Table Section */}
                            <div className="card border">
                                <div className="card-header bg-white border-bottom py-3">
                                    <div className="row align-items-center">
                                        <div className="col">
                                            <h6 className="mb-0 fw-semibold">
                                                <i className="ri-list-check-2 me-2"></i>
                                                Allocated Coupons
                                            </h6>
                                            <small className="text-muted">
                                                Showing {filteredData.length} of {pagination.totalRecords} records
                                                {statusFilter !== 'ALL' && ` • ${statusFilter} only`}
                                                {dateFilter !== 'ALL' && ` • ${dateFilter.toLowerCase()} coupons`}
                                            </small>
                                        </div>
                                        <div className="col-auto">
                                            <div className="d-flex align-items-center gap-2">
                                                <span className="text-muted">Show:</span>
                                                <Form.Select
                                                    size="sm"
                                                    style={{ width: '80px' }}
                                                    value={pagination.rowsPerPage}
                                                    onChange={(e) => handleRowsPerPageChange(Number(e.target.value))}
                                                >
                                                    <option value={5}>5</option>
                                                    <option value={10}>10</option>
                                                    <option value={25}>25</option>
                                                    <option value={50}>50</option>
                                                    <option value={100}>100</option>
                                                </Form.Select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body p-0">
                                    {fetchLoading ? (
                                        <div className="text-center py-5">
                                            <Spinner animation="border" variant="primary" />
                                            <p className="mt-2 text-muted">Loading coupons...</p>
                                        </div>
                                    ) : filteredData.length === 0 ? (
                                        <div className="text-center py-5">
                                            <i className="ri-coupon-line fs-1 text-muted mb-3"></i>
                                            <h5 className="text-muted">No coupons found</h5>
                                            <p className="text-muted">Try adjusting your filters or add a new coupon</p>
                                        </div>
                                    ) : (
                                        <div className="table-responsive">
                                            <ReusableTable
                                                columns={columns}
                                                data={getPaginatedData()}
                                                rowKey="serialNumber"
                                                currentPage={pagination.page}
                                                recordsPerPage={pagination.rowsPerPage}
                                                onPageChange={handlePageChange}
                                                totalPages={pagination.totalPages}
                                                totalRecords={pagination.totalRecords}
                                                onRecordsPerPageChange={handleRowsPerPageChange}
                                                loading={fetchLoading}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Add New Coupon Modal */}
                    <Modal
                        show={addNewOpenModal}
                        onHide={handleCloseAddNewOpenModal}
                        centered
                        size="xl"
                        dialogClassName="modal-fullscreen-lg-down"
                    >
                        <Modal.Header closeButton className="bg-light">
                            <Modal.Title className="fw-bold">
                                <i className="ri-coupon-add-line me-2 text-primary"></i>
                                Allocate New Coupon
                            </Modal.Title>
                        </Modal.Header>
                        <Form onSubmit={handleSubmitCoupon}>
                            <Modal.Body className="p-4" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                                {/* <div className="stepper mb-4">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="step active">
                                            <div className="step-icon bg-primary text-white">1</div>
                                            <div className="step-label">User Selection</div>
                                        </div>
                                        <div className="step-line"></div>
                                        <div className="step">
                                            <div className="step-icon">2</div>
                                            <div className="step-label">Coupon Details</div>
                                        </div>
                                        <div className="step-line"></div>
                                        <div className="step">
                                            <div className="step-icon">3</div>
                                            <div className="step-label">Configuration</div>
                                        </div>
                                    </div>
                                </div> */}

                                <Row className="g-3">
                                    {/* Step 1: User Selection */}
                                    <div className="mb-2">
                                        <h6 className="fw-bold mb-3">
                                            <i className="ri-user-add-line me-2 text-primary"></i>
                                            Step 1: Select Users
                                        </h6>
                                        <Row className="g-2">
                                            <Col md={12} className="mb-2">
                                                <div className="card border">
                                                    <div className="card-body">
                                                        <Form.Label className="fw-semibold">
                                                            <i className="ri-upload-cloud-line me-2"></i>
                                                            Upload Users File (Optional)
                                                        </Form.Label>
                                                        <div className="input-group">
                                                            <Form.Control
                                                                type="file"
                                                                accept=".xls, .xlsx"
                                                                onChange={(e) => handleFileUpload(e.target.files[0])}
                                                            />
                                                            <Button variant="outline-secondary">
                                                                <i className="ri-upload-line"></i>
                                                            </Button>
                                                        </div>
                                                        <small className="text-muted mt-2 d-block">
                                                            Upload Excel file with user IDs. If not uploading, select users manually below.
                                                        </small>
                                                        {file && (
                                                            <div className="alert alert-success mt-2 py-2">
                                                                <i className="ri-check-line me-2"></i>
                                                                File loaded: {file.name} ({usersFromFile.length} users)
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </Col>

                                            <Col md={12} className="mb-2">
                                                <div className="card border">
                                                    <div className="card-body">
                                                        <Form.Label className="fw-semibold">
                                                            <i className="ri-user-search-line me-2"></i>
                                                            Select Users Manually
                                                        </Form.Label>
                                                        <Select
                                                            isMulti
                                                            options={usersInfo}
                                                            value={selectedUsers}
                                                            onChange={handleSelectUsersChange}
                                                            onInputChange={(query) => {
                                                                debouncedGetUsersList(query);
                                                            }}
                                                            placeholder="Search and select users..."
                                                            closeMenuOnSelect={false}
                                                            styles={customStyles}
                                                            isDisabled={!!file}
                                                            theme={(theme) => ({
                                                                ...theme,
                                                                borderRadius: 6,
                                                                colors: {
                                                                    ...theme.colors,
                                                                    primary25: "#e7f1ff",
                                                                    primary: "#2684ff",
                                                                },
                                                            })}
                                                        />
                                                        <div className="d-flex justify-content-between align-items-center mt-2">
                                                            <small className="text-muted">
                                                                {selectedUsers.length} user(s) selected
                                                            </small>
                                                            {selectedUsers.length > 0 && (
                                                                <Button
                                                                    variant="link"
                                                                    size="sm"
                                                                    onClick={() => setSelectedUsers([])}
                                                                    className="text-danger p-0"
                                                                >
                                                                    <i className="ri-close-line me-1"></i> Clear All
                                                                </Button>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>

                                    {/* Step 2: Coupon Type Selection */}
                                    <div className="mb-2">
                                        <h6 className="fw-bold mb-3">
                                            <i className="ri-coupon-3-line me-2 text-primary"></i>
                                            Step 2: Select Coupon Type
                                        </h6>
                                        <Card className="border">
                                            <Card.Body>
                                                <Row className="g-3">
                                                    {checkboxes?.map(({ id, label, field, icon }) => (
                                                        <Col md={4} lg={2} key={id}>
                                                            <div className="form-check card-option">
                                                                <Form.Check
                                                                    type="checkbox"
                                                                    id={id}
                                                                    label={
                                                                        <div className="d-flex flex-column align-items-center">
                                                                            <i className={`${icon} fs-4 mb-2 ${couponData[field] ? 'text-primary' : 'text-muted'}`}></i>
                                                                            <span className="small">{label}</span>
                                                                        </div>
                                                                    }
                                                                    checked={couponData[field]}
                                                                    onChange={handleCheckboxChange(field)}
                                                                    className={`custom-checkbox fw-semibold ${couponData[field] ? 'active' : ''}`}
                                                                />
                                                            </div>
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </div>

                                    {/* Step 3: Coupon Details */}
                                    <div className="mb-2">
                                        <h6 className="fw-bold mb-3">
                                            <i className="ri-information-line me-2 text-primary"></i>
                                            Step 3: Coupon Details
                                        </h6>
                                        <Row className="g-3">
                                            <Col md={3}>
                                                <div className="form-floating">
                                                    <Form.Control
                                                        placeholder="Title"
                                                        name="title"
                                                        value={couponData.title || ""}
                                                        onChange={handleInputChange}
                                                        required
                                                    />
                                                    <Form.Label>
                                                        Title <span className="text-danger">*</span>
                                                    </Form.Label>
                                                </div>
                                            </Col>

                                            <Col md={3}>
                                                <div className="form-floating">
                                                    <Form.Control
                                                        placeholder="Coupon Code"
                                                        name="couponCode"
                                                        value={couponData.couponCode || ""}
                                                        onChange={handleInputChange}
                                                        required
                                                    />
                                                    <Form.Label>
                                                        Coupon Code <span className="text-danger">*</span>
                                                    </Form.Label>
                                                </div>
                                            </Col>

                                            <Col md={3}>
                                                <div className="form-floating">
                                                    <Form.Select
                                                        name="usageType"
                                                        value={couponData.usageType}
                                                        onChange={handleInputChange}
                                                        required
                                                    >
                                                        <option value="">Select Usage Type</option>
                                                        <option value="ONE-TIME">ONE-TIME</option>
                                                        <option value="MULTIPLE">MULTIPLE</option>
                                                    </Form.Select>
                                                    <Form.Label>
                                                        Usage Type <span className="text-danger">*</span>
                                                    </Form.Label>
                                                </div>
                                            </Col>

                                            <Col md={3}>
                                                <div className="form-floating">
                                                    <Form.Control
                                                        min={0}
                                                        placeholder="Daily Usage Limit"
                                                        name="dailyUsageLimit"
                                                        value={couponData.dailyUsageLimit || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                    <Form.Label>Daily Usage Limit</Form.Label>
                                                </div>
                                            </Col>

                                            <Col md={3}>
                                                <Form.Label>
                                                    Start Date <span className="text-danger">*</span>
                                                </Form.Label>
                                                <div className="form-floating">
                                                    <DatePicker
                                                        selected={fromDate}
                                                        onChange={handleFromDateChange}
                                                        placeholderText="Start Date"
                                                        className="form-control"
                                                        style={{ zIndex: 100 }}
                                                        dateFormat="dd/MM/yyyy"
                                                        minDate={new Date()}
                                                        required
                                                        popperClassName="datepicker-popper"
                                                    />
                                                </div>
                                            </Col>

                                            <Col md={3}>
                                                <Form.Label>
                                                    End Date <span className="text-danger">*</span>
                                                </Form.Label>
                                                <div className="form-floating">
                                                    <DatePicker
                                                        selected={toDate}
                                                        onChange={handleToDateChange}
                                                        placeholderText="End Date"
                                                        className="form-control"
                                                        dateFormat="dd/MM/yyyy"
                                                        minDate={fromDate || new Date()}
                                                        required
                                                        popperClassName="datepicker-popper"
                                                    />
                                                </div>
                                            </Col>

                                            <Col md={3}>
                                                <div className="form-floating">
                                                    <Form.Control
                                                        type="time"
                                                        name="startTime"
                                                        value={couponData.startTime}
                                                        onChange={handleInputChange}
                                                    />
                                                    <Form.Label>Start Time</Form.Label>
                                                </div>
                                            </Col>

                                            <Col md={3}>
                                                <div className="form-floating">
                                                    <Form.Control
                                                        type="time"
                                                        name="endTime"
                                                        value={couponData.endTime}
                                                        onChange={handleInputChange}
                                                    />
                                                    <Form.Label>End Time</Form.Label>
                                                </div>
                                            </Col>


                                            {/* Freebie Coupon Fields */}
                                            {couponData.isFreebieCoupon && (
                                                <>
                                                    <Col md={6}>
                                                        <Form.Label className='mb-1'>
                                                            Freebie Product <span className="text-danger">*</span>
                                                        </Form.Label>
                                                        {/* <div className="form-floating"> */}
                                                        <Select
                                                            name="freebieProduct"
                                                            options={freebieProductsOptions}
                                                            value={freebieProductsOptions.find(option => option.value === couponData.freebieProduct) || null}
                                                            onChange={(selectedOption) => {
                                                                setCouponData(prev => ({
                                                                    ...prev,
                                                                    freebieProduct: selectedOption ? selectedOption.value : ""
                                                                }));
                                                            }}
                                                            isClearable
                                                            placeholder="Select Freebie Product"
                                                            classNamePrefix="react-select"
                                                            styles={customStyles}
                                                            required

                                                        />

                                                        {/* </div> */}
                                                    </Col>

                                                    <Col md={2}>
                                                        <div className="form-floating">
                                                            <Form.Control
                                                                type="number"
                                                                min="1"
                                                                name="freebieQuantity"
                                                                value={couponData.freebieQuantity || ""}
                                                                onChange={handleInputChange}
                                                                placeholder="Quantity"
                                                                required
                                                            />
                                                            <Form.Label>
                                                                Quantity <span className="text-danger">*</span>
                                                            </Form.Label>
                                                        </div>
                                                    </Col>
                                                </>
                                            )}
                                        </Row>
                                    </div>

                                    {/* Step 4: Advanced Configuration */}
                                    <div className="mb-2">
                                        <h6 className="fw-bold mb-3">
                                            <i className="ri-settings-3-line me-2 text-primary"></i>
                                            Step 4: Advanced Configuration
                                        </h6>
                                        <Row className="g-3">
                                            {/* Discount Fields */}
                                            {!couponData.isFreebieCoupon && !couponData.isBogoCoupon && !couponData.isSizeUpgradeCoupon && (
                                                <>
                                                    <Col md={3}>
                                                        <div className="form-floating">
                                                            <Form.Control
                                                                min={0}
                                                                max={100}
                                                                disabled={couponData?.discountAmount || couponData?.discountPrice}
                                                                placeholder="Discount Percent"
                                                                type="number"
                                                                name="discountPercent"
                                                                value={couponData.discountPercent || ""}
                                                                onChange={handleInputChange}
                                                            />
                                                            <Form.Label>Discount %</Form.Label>
                                                        </div>
                                                    </Col>

                                                    <Col md={3}>
                                                        <div className="form-floating">
                                                            <Form.Control
                                                                min={0}
                                                                disabled={couponData.isBogoCoupon || couponData.isSizeUpgradeCoupon || couponData.discountAmount || couponData.discountPrice}
                                                                placeholder="Max. Dis. Amount"
                                                                type="number"
                                                                name="maxDiscountAmount"
                                                                value={couponData.maxDiscountAmount}
                                                                onChange={handleInputChange}
                                                            />
                                                            <Form.Label>Max Discount</Form.Label>
                                                        </div>
                                                    </Col>

                                                    <Col md={3}>
                                                        <div className="form-floating">
                                                            <Form.Control
                                                                min={0}
                                                                step={0.01}
                                                                disabled={couponData?.discountPercent || couponData?.discountPrice || universalCoupon}
                                                                placeholder="Discount Amount"
                                                                type="number"
                                                                name="discountAmount"
                                                                value={couponData.discountAmount || ""}
                                                                onChange={handleInputChange}
                                                            />
                                                            <Form.Label>Flat Discount</Form.Label>
                                                        </div>
                                                    </Col>

                                                    <Col md={3}>
                                                        <div className="form-floating">
                                                            <Form.Control
                                                                min={0}
                                                                step={0.01}
                                                                disabled={couponData?.discountAmount || couponData?.discountPercent || universalCoupon}
                                                                placeholder="Discount Price"
                                                                type="number"
                                                                name="discountPrice"
                                                                value={couponData.discountPrice || ""}
                                                                onChange={handleInputChange}
                                                            />
                                                            <Form.Label>Discount Price</Form.Label>
                                                        </div>
                                                    </Col>
                                                </>
                                            )}

                                            {/* Size Upgrade Addon */}
                                            {couponData.isSizeUpgradeCoupon && (
                                                <Col md={4}>
                                                    <div className="form-floating">
                                                        <Form.Select
                                                            name="newSizeUpgradeAddon"
                                                            value={couponData.newSizeUpgradeAddon}
                                                            onChange={(e) => setCouponData((prev) => ({
                                                                ...prev,
                                                                newSizeUpgradeAddon: e.target.value,
                                                            }))}
                                                            required
                                                        >
                                                            <option value="">Select Size Upgrade Addon</option>
                                                            {newSizeAddonsList?.map((addon) => (
                                                                <option key={addon._id} value={addon._id}>
                                                                    {addon.title} [{addon.identifier}]
                                                                </option>
                                                            ))}
                                                        </Form.Select>
                                                        <Form.Label>
                                                            Size Upgrade Addon <span className="text-danger">*</span>
                                                        </Form.Label>
                                                    </div>
                                                </Col>
                                            )}

                                            {/* Other Fields */}
                                            <Col md={3}>
                                                <div className="form-floating">
                                                    <Form.Select
                                                        name="orderType"
                                                        value={couponData.orderType || "ALL"}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="ALL">ALL</option>
                                                        <option value="DELIVERY">DELIVERY</option>
                                                        <option value="PICKUP">PICK-UP</option>
                                                    </Form.Select>
                                                    <Form.Label>Order Type</Form.Label>
                                                </div>
                                            </Col>

                                            <Col md={3}>
                                                <div className="form-floating">
                                                    <Form.Control
                                                        min={0}
                                                        placeholder="Min. Order Amount"
                                                        type="number"
                                                        name="minOrderAmount"
                                                        value={couponData.minOrderAmount}
                                                        onChange={handleInputChange}
                                                    />
                                                    <Form.Label>Min. Order Amount</Form.Label>
                                                </div>
                                            </Col>

                                            <Col md={3}>
                                                <div className="form-floating">
                                                    <Form.Select
                                                        name="dayOfWeek"
                                                        value={couponData?.dayOfWeek || ""}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value="">Any Day</option>
                                                        <option value="0">Sunday</option>
                                                        <option value="1">Monday</option>
                                                        <option value="2">Tuesday</option>
                                                        <option value="3">Wednesday</option>
                                                        <option value="4">Thursday</option>
                                                        <option value="5">Friday</option>
                                                        <option value="6">Saturday</option>
                                                    </Form.Select>
                                                    <Form.Label>Applicable Day</Form.Label>
                                                </div>
                                            </Col>



                                            <Col md={12}>
                                                <div className="form-floating">
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={2}
                                                        placeholder="Description"
                                                        name="description"
                                                        value={couponData.description || ""}
                                                        onChange={handleInputChange}
                                                        style={{ minHeight: '100px' }}
                                                    />
                                                    <Form.Label>Description</Form.Label>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>

                                    {/* Multi-Select Components Section */}
                                    <div className="mb-2">
                                        <h6 className="fw-bold mb-3">
                                            <i className="ri-filter-2-line me-2 text-primary"></i>
                                            Advanced Filters & Restrictions
                                        </h6>

                                        <Row className="g-3">
                                            {/* Applicable Categories & Products */}
                                            <Col md={6}>
                                                <div className="card border h-100">
                                                    <div className="card-header bg-light py-2">
                                                        <h6 className="mb-0">
                                                            <i className="ri-list-check me-2"></i>
                                                            Product & Category Filters
                                                        </h6>
                                                    </div>
                                                    <div className="card-body">
                                                        <MultiSelectComponent
                                                            label="Applicable Categories"
                                                            placeholder="Select categories"
                                                            value={selections.selectedApplicableCategories || []}
                                                            onChange={(value) => handleChange("selectedApplicableCategories", value)}
                                                            options={categoriesData}
                                                            isDisabled={!!selections.selectedApplicableProducts?.length || couponData?.isComboCategoryCoupon || couponData.isFreebieCoupon}
                                                            helpText="Products from these categories will be eligible"
                                                        />

                                                        <MultiSelectComponent
                                                            label="Applicable Products"
                                                            placeholder="Select specific products"
                                                            value={selections.selectedApplicableProducts || []}
                                                            onChange={(value) => handleChange("selectedApplicableProducts", value)}
                                                            options={productsInfo}
                                                            isDisabled={!!selections.selectedApplicableCategories?.length || couponData.isBogoCoupon || couponData?.isComboCategoryCoupon || couponData.isFreebieCoupon || universalCoupon}
                                                            helpText="Only these specific products will be eligible"
                                                        />
                                                    </div>
                                                </div>
                                            </Col>

                                            {/* Combo Categories */}
                                            {couponData?.isComboCategoryCoupon && (
                                                <Col md={6}>
                                                    <div className="card border h-100">
                                                        <div className="card-header bg-light py-2">
                                                            <h6 className="mb-0">
                                                                <i className="ri-links-line me-2"></i>
                                                                Combo Categories (For Combo Coupons)
                                                            </h6>
                                                        </div>
                                                        <div className="card-body">
                                                            <MultiSelectComponent
                                                                label="Primary Combo Categories"
                                                                placeholder="Select primary categories"
                                                                value={selections.primaryComboCategories || []}
                                                                onChange={(value) => handleChange("primaryComboCategories", value)}
                                                                options={categoriesData.filter(
                                                                    (category) =>
                                                                        !selections.secondaryComboCategories?.some(
                                                                            (cat) => cat.value === category.value
                                                                        )
                                                                )}
                                                                isDisabled={couponData.isBogoCoupon || couponData?.isSizeUpgradeCoupon || couponData?.isMrpDiscount || couponData.isFreebieCoupon}
                                                                helpText="Primary categories for combo discounts"
                                                            />

                                                            <MultiSelectComponent
                                                                label="Secondary Combo Categories"
                                                                placeholder="Select secondary categories"
                                                                value={selections.secondaryComboCategories || []}
                                                                onChange={(value) => handleChange("secondaryComboCategories", value)}
                                                                options={categoriesData.filter(
                                                                    (category) =>
                                                                        !selections.primaryComboCategories?.some(
                                                                            (cat) => cat.value === category.value
                                                                        )
                                                                )}
                                                                isDisabled={couponData.isBogoCoupon || couponData?.isSizeUpgradeCoupon || couponData?.isMrpDiscount || couponData.isFreebieCoupon}
                                                                helpText="Secondary categories that combine with primary"
                                                            />
                                                        </div>
                                                    </div>
                                                </Col>
                                            )}


                                            {/* Exclusions */}
                                            <Col md={6}>
                                                <div className="card border h-100">
                                                    <div className="card-header bg-light py-2">
                                                        <h6 className="mb-0">
                                                            <i className="ri-forbid-line me-2"></i>
                                                            Exclusions
                                                        </h6>
                                                    </div>
                                                    <div className="card-body">
                                                        <MultiSelectComponent
                                                            label="Include Outlets"
                                                            placeholder="Select outlets to include"
                                                            options={outletData.filter(
                                                                (outlet) =>
                                                                    !selections?.selectedExcludedOutlets?.some(
                                                                        (excludedOutlet) => excludedOutlet.value === outlet.value
                                                                    )
                                                            )}
                                                            value={selections?.selectedIncludedOutlets || []}
                                                            onChange={(value) => handleChange("selectedIncludedOutlets", value)}
                                                            isDisabled={!!selections?.selectedExcludedOutlets?.length}
                                                        />

                                                        <MultiSelectComponent
                                                            label="Exclude Outlets"
                                                            placeholder="Select outlets to exclude"
                                                            value={selections.selectedExcludedOutlets || []}
                                                            onChange={(value) => handleChange("selectedExcludedOutlets", value)}
                                                            options={outletData.filter(
                                                                (outlet) =>
                                                                    !selections.selectedIncludedOutlets?.some(
                                                                        (includedOutlet) => includedOutlet.value === outlet.value
                                                                    )
                                                            )}
                                                            isDisabled={!!selections.selectedIncludedOutlets?.length}
                                                        />
                                                        <MultiSelectComponent
                                                            label="Excluded Products"
                                                            placeholder="Select products to exclude"
                                                            value={selections.selectedExcludedProducts || []}
                                                            onChange={(value) => handleChange("selectedExcludedProducts", value)}
                                                            options={exProductsInfo}
                                                            helpText="These products will NOT be eligible for the coupon"
                                                        />


                                                    </div>
                                                </div>
                                            </Col>

                                            {/* Dependencies */}
                                            <Col md={6}>
                                                <div className="card border h-100">
                                                    <div className="card-header bg-light py-2">
                                                        <h6 className="mb-0">
                                                            <i className="ri-node-tree me-2"></i>
                                                            Dependencies
                                                        </h6>
                                                    </div>
                                                    <div className="card-body">
                                                        <MultiSelectComponent
                                                            label="Dependent Products"
                                                            placeholder="Select dependent products"
                                                            value={selections.selectedDependentProducts || []}
                                                            onChange={(value) => handleChange("selectedDependentProducts", value)}
                                                            options={productsInfo}
                                                            customStyles={customStyles}
                                                            isDisabled={couponData.isBogoCoupon || couponData?.isSizeUpgradeCoupon || couponData?.isComboCategoryCoupon || couponData.isFreebieCoupon}
                                                            helpText="Products that must be in cart for coupon to apply"
                                                        />
                                                        <MultiSelectComponent
                                                            label="Dependent Categories"
                                                            placeholder="Select dependent categories"
                                                            value={selections.selectedDependentCategories || []}
                                                            onChange={(value) => handleChange("selectedDependentCategories", value)}
                                                            options={categoriesData}
                                                            isDisabled={couponData.isBogoCoupon || couponData?.isSizeUpgradeCoupon || couponData?.isComboCategoryCoupon || couponData.isFreebieCoupon}
                                                            helpText="Categories that must be in cart for coupon to apply"
                                                        />
                                                    </div>
                                                </div>
                                            </Col>

                                            {/* Location & Level Filters */}
                                            <Col md={6}>
                                                <div className="card border h-100">
                                                    <div className="card-header bg-light py-2">
                                                        <h6 className="mb-0">
                                                            <i className="ri-store-line me-2"></i>
                                                            User Level Filters & Addon Limit
                                                        </h6>
                                                    </div>
                                                    <div className="card-body">
                                                        <MultiSelectComponent
                                                            label="Applicable Levels"
                                                            placeholder="Select user levels"
                                                            value={selections.selectedApplicableLevels || []}
                                                            onChange={(value) => handleChange("selectedApplicableLevels", value)}
                                                            options={levelsData}
                                                            helpText="Only users at these levels can use this coupon"
                                                        />
                                                        <div className="form-floating">
                                                            <Form.Control
                                                                min={0}
                                                                placeholder="Maximum Addons Allowed"
                                                                type="number"
                                                                name="maxAddonsAllowed"
                                                                value={couponData.maxAddonsAllowed || ""}
                                                                onChange={handleInputChange}
                                                                disabled={couponData.isFreebieCoupon}
                                                            />
                                                            <Form.Label>Max Addons Allowed</Form.Label>
                                                            <small className="text-muted d-block mt-1">
                                                                Maximum number of addons allowed per item (0 = no limit)
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>

                                            {/* Addon Exclusions */}
                                            <Col md={6}>
                                                <div className="card border h-100">
                                                    <div className="card-header bg-light py-2">
                                                        <h6 className="mb-0">
                                                            <i className="ri-list-settings-line me-2"></i>
                                                            Addon Exclusions
                                                        </h6>
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="mb-3">
                                                            <Form.Label className="fw-semibold">
                                                                <i className="ri-list-check me-2"></i>
                                                                Excluding Addon Groups
                                                            </Form.Label>
                                                            <Select
                                                                components={animatedComponents}
                                                                isMulti
                                                                options={allAddonList.map(addon => ({
                                                                    value: addon._id,
                                                                    label: addon.title,
                                                                    icon: addon.icon || "ri-list-settings"
                                                                }))}
                                                                value={selectedAddonGroups}
                                                                onChange={(options) => handleSelectAllAddonChange('excludedAddonGroups', options)}
                                                                className="basic-multi-select"
                                                                classNamePrefix="select"
                                                                placeholder="Select addon groups to exclude..."
                                                                isDisabled={couponData.isFreebieCoupon}
                                                                styles={customStyles}
                                                                formatOptionLabel={({ label, icon }) => (
                                                                    <div className="d-flex align-items-center">
                                                                        <i className={`${icon || 'ri-list-settings'} me-2`}></i>
                                                                        <span>{label}</span>
                                                                    </div>
                                                                )}
                                                            />
                                                            <small className="text-muted mt-1 d-block">
                                                                Select addon groups whose values should be excluded
                                                            </small>
                                                        </div>

                                                        <div className="mb-3">
                                                            <Form.Label className="fw-semibold">
                                                                <i className="ri-list-settings-line me-2"></i>
                                                                Excluding Addon Values
                                                            </Form.Label>
                                                            <Select
                                                                components={animatedComponents}
                                                                isMulti
                                                                options={filteredAddonValues}
                                                                value={selectedAddonValues}
                                                                onChange={handleAddonValueChange}
                                                                className="basic-multi-select"
                                                                classNamePrefix="select"
                                                                placeholder={
                                                                    selectedAddonGroups.length === 0
                                                                        ? "Select addon groups first"
                                                                        : "Select specific addon values to exclude"
                                                                }
                                                                getOptionLabel={(option) => option.label}
                                                                getOptionValue={(option) => `${option.value.addonId}-${option.value.addonValueId}`}
                                                                isDisabled={selectedAddonGroups.length === 0 || couponData.isFreebieCoupon}
                                                                styles={customStyles}
                                                            />
                                                            <small className="text-muted mt-1 d-block">
                                                                {selectedAddonValues.length > 0
                                                                    ? `${selectedAddonValues.length} addon value(s) selected`
                                                                    : "No addon values excluded"
                                                                }
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>

                                            {/* Max Addons Allowed */}
                                            <Col md={4}>
                                                <div className="card border h-100">
                                                    <div className="card-header bg-light py-2">
                                                        <h6 className="mb-0">
                                                            <i className="ri-add-circle-line me-2"></i>
                                                            Addon Limits
                                                        </h6>
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="form-floating">
                                                            <Form.Control
                                                                min={0}
                                                                placeholder="Maximum Addons Allowed"
                                                                type="number"
                                                                name="maxAddonsAllowed"
                                                                value={couponData.maxAddonsAllowed || ""}
                                                                onChange={handleInputChange}
                                                                disabled={couponData.isFreebieCoupon}
                                                            />
                                                            <Form.Label>Max Addons Allowed</Form.Label>
                                                            <small className="text-muted d-block mt-1">
                                                                Maximum number of addons allowed per item (0 = no limit)
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>

                                            {/* Applicable Quantity Type */}
                                            <Col md={4}>
                                                <div className="card border h-100">
                                                    <div className="card-header bg-light py-2">
                                                        <h6 className="mb-0">
                                                            <i className="ri-number-1 me-2"></i>
                                                            Quantity Restrictions
                                                        </h6>
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="form-floating">
                                                            <Form.Select
                                                                name="applicableQuantityType"
                                                                value={couponData.applicableQuantityType || ""}
                                                                onChange={handleInputChange}
                                                                disabled={
                                                                    couponData?.discountPercent ||
                                                                    couponData?.discountAmount ||
                                                                    couponData?.isBogoCoupon ||
                                                                    couponData.isSizeUpgradeCoupon ||
                                                                    couponData?.isMrpDiscount ||
                                                                    couponData.isFreebieCoupon
                                                                }
                                                            >
                                                                <option value="">Select Quantity Type</option>
                                                                <option value="SINGLE">SINGLE (One item only)</option>
                                                                {!couponData?.isComboCategoryCoupon && (
                                                                    <option value="MULTIPLE">MULTIPLE (Multiple items)</option>
                                                                )}
                                                            </Form.Select>
                                                            <Form.Label>Applicable Quantity Type</Form.Label>
                                                            <small className="text-muted d-block mt-1">
                                                                Restricts coupon to single or multiple items
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>

                                            {/* Hide Coupon Option */}
                                            <Col md={4}>
                                                <div className="card border h-100">
                                                    <div className="card-header bg-light py-2">
                                                        <h6 className="mb-0">
                                                            <i className="ri-eye-off-line me-2"></i>
                                                            Visibility
                                                        </h6>
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="form-floating">
                                                            <Form.Select
                                                                name="isHidden"
                                                                value={couponData.isHidden || "false"}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="false">Visible to Users</option>
                                                                <option value="true">Hidden from Users</option>
                                                            </Form.Select>
                                                            <Form.Label>Coupon Visibility</Form.Label>
                                                            <small className="text-muted d-block mt-1">
                                                                Hide coupon from user view if needed
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>

                                        </Row>
                                    </div>

                                    {/* Terms and Conditions */}
                                    <div className="mb-2">
                                        <h6 className="fw-bold mb-3">
                                            <i className="ri-file-text-line me-2 text-primary"></i>
                                            Terms & Conditions
                                        </h6>
                                        <div className="card border">
                                            <div className="card-body">
                                                <div className="d-flex mb-3">
                                                    <Form.Control
                                                        placeholder="Enter term..."
                                                        value={currentTerm}
                                                        onChange={(e) => setCurrentTerm(e.target.value)}
                                                        className="me-2"
                                                    />
                                                    <Button
                                                        variant="primary"
                                                        onClick={addTerm}
                                                        disabled={!currentTerm.trim()}
                                                    >
                                                        <i className="ri-add-line me-1"></i> Add
                                                    </Button>
                                                </div>
                                                {couponData?.termsAndConditions?.length > 0 && (
                                                    <div className="terms-list">
                                                        {couponData?.termsAndConditions?.map((term, index) => (
                                                            <div key={index} className="alert alert-light d-flex justify-content-between align-items-center mb-2">
                                                                <span>{term}</span>
                                                                <Button
                                                                    variant="outline-danger"
                                                                    size="sm"
                                                                    onClick={() => removeTerm(index)}
                                                                >
                                                                    <i className="ri-close-line"></i>
                                                                </Button>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </Row>
                            </Modal.Body>
                            <Modal.Footer className="bg-light">
                                <Button
                                    variant="outline-secondary"
                                    onClick={handleCloseAddNewOpenModal}
                                >
                                    <i className="ri-close-line me-1"></i> Cancel
                                </Button>
                                <Button
                                    variant="primary"
                                    type="submit"
                                    disabled={isLoading}
                                >
                                    {isLoading ? (
                                        <>
                                            <Spinner animation="border" size="sm" className="me-2" />
                                            Creating...
                                        </>
                                    ) : (
                                        <>
                                            <i className="ri-check-line me-1"></i> Create Coupon
                                        </>
                                    )}
                                </Button>
                            </Modal.Footer>
                        </Form>
                    </Modal>

                    {/* View Modal */}
                    {openViewModal && (
                        <Modal
                            centered
                            show={openViewModal}
                            onHide={() => setOpenViewModal(false)}
                            size="xl"
                        >
                            <Modal.Header closeButton className="bg-primary text-white">
                                <Modal.Title>
                                    <i className="ri-eye-line me-2"></i>
                                    Coupon Details
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {/* Coupon Details Section */}
                                <div className="mb-4">
                                    <h5 className="text-center fw-bold text-primary mb-3">COUPON DETAILS</h5>
                                    {/* <Table bordered hover>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td className='w-50 fw-semibold'>Title</td>
                                                                                <td>{couponDetails?.title}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className='fw-semibold'>Description</td>
                                                                                <td>{couponDetails?.description}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className='fw-semibold'>Coupon Code</td>
                                                                                <td className='fw-bold' style={{ color: 'blueviolet' }}>{couponDetails?.couponCode}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className='fw-semibold'>Usage-Type</td>
                                                                                <td>{couponDetails?.usageType}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className='fw-semibold'>Order Type</td>
                                                                                <td>{couponDetails?.orderType}</td>
                                                                            </tr>
                                                                            {couponDetails?.dayOfWeek === null && (
                                                                                <tr>
                                                                                    <td className='fw-semibold'>Applicable Days</td>
                                                                                    <td>On any day of the week</td>
                                                                                </tr>
                                                                            )}
                                                                            {couponDetails?.dayOfWeek && (
                                                                                <tr>
                                                                                    <td className='fw-semibold'>Applicable Days</td>
                                                                                    <td>
                                                                                        {couponDetails?.dayOfWeek !== undefined ? getDayOfWeek(couponDetails.dayOfWeek) : couponDetails?.dayOfWeek === 'all' ? 'On any day of the week' : "N/A"}
                                                                                    </td>
                                                                                </tr>
                                                                            )}
                                                                            {couponDetails?.maxAddonsAllowed && (
                                                                                <tr>
                                                                                    <td className='fw-semibold'>Maximum Addon Allowed</td>
                                                                                    <td>{couponDetails?.maxAddonsAllowed}</td>
                                                                                </tr>
                                                                            )}
                                                                            <tr>
                                                                                <td className='fw-semibold'>BOGO Coupon</td>
                                                                                <td>
                                                                                    {couponDetails?.isBogoCoupon ? <span className='text-success fw-semibold'>YES </span> : <span className='text-danger fw-semibold'>NO </span>}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className='fw-semibold'>Size Upgrade Coupon</td>
                                                                                <td>
                                                                                    {couponDetails?.newSizeUpgradeAddon ? <span className='text-success fw-semibold'>YES </span> : <span className='text-danger fw-semibold'>NO </span>}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className='fw-semibold'>Combo Category Coupon</td>
                                                                                <td>
                                                                                    {couponDetails?.isComboCategoryCoupon ? <span className='text-success fw-semibold'>YES </span> : <span className='text-danger fw-semibold'>NO </span>}
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className='fw-semibold'>MRP Coupon</td>
                                                                                <td>
                                                                                    {couponDetails?.isMrpDiscount ? <span className='text-success fw-semibold'>YES </span> : <span className='text-danger fw-semibold'>NO </span>}
                                                                                </td>
                                                                            </tr>
                                                                            {couponDetails?.isFreebieCoupon && (
                                                                                <>
                                                                                    <tr>
                                                                                        <td className='fw-semibold'>Freebie Product</td>
                                                                                        <td className='text-success fw-semibold'>
                                                                                            {couponDetails?.freebieProduct?.name || "N/A"}
                                                                                        </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td className='fw-semibold'>Freebie Quantity</td>
                                                                                        <td className='text-success fw-semibold'>
                                                                                            {couponDetails?.freebieQuantity || 1}
                                                                                        </td>
                                                                                    </tr>
                                                                                </>
                                                                            )}
                                                                            {couponDetails?.applicableCategories?.length > 0 && (
                                                                                <tr>
                                                                                    <td className='fw-semibold'>Applicable Categories</td>
                                                                                    <td>
                                                                                        {couponDetails?.applicableCategories.map((item) => item?.name).join(', ')}
                                                                                    </td>
                                                                                </tr>
                                                                            )}
                                                                            {couponDetails?.excludedProducts?.length > 0 && (
                                                                                <tr>
                                                                                    <td className='fw-semibold'>Excluded Products</td>
                                                                                    <td>
                                                                                        {couponDetails?.excludedProducts.map((item) => item?.name).join(', ')}
                                                                                    </td>
                                                                                </tr>
                                                                            )}
                                                                            {couponDetails?.applicableProducts?.length > 0 && (
                                                                                <tr>
                                                                                    <td className='fw-semibold'>Applicable Products</td>
                                                                                    <td>
                                                                                        {couponDetails?.applicableProducts.map((item) => item?.name).join(', ')}
                                                                                    </td>
                                                                                </tr>
                                                                            )}
                                                                            {couponDetails?.excludedAddons?.length > 0 && (
                                                                                <tr>
                                                                                    <td className='fw-semibold'>Excluded Addons</td>
                                                                                    <td>
                                                                                        {(() => {
                                                                                            const groupedAddons = couponDetails.excludedAddons.reduce((acc, addon) => {
                                                                                                if (!acc[addon.addonTitle]) {
                                                                                                    acc[addon.addonTitle] = [];
                                                                                                }
                                                                                                acc[addon.addonTitle].push(addon.addonValueTitle);
                                                                                                return acc;
                                                                                            }, {});
                                
                                                                                            return Object.entries(groupedAddons).map(([addonTitle, values]) => (
                                                                                                <div key={addonTitle}>
                                                                                                    <strong>{addonTitle}</strong>: {values.join(', ')}
                                                                                                </div>
                                                                                            ));
                                                                                        })()}
                                                                                    </td>
                                                                                </tr>
                                                                            )}
                                                                            {couponDetails?.applicableLevels?.length > 0 && (
                                                                                <tr>
                                                                                    <td className='fw-semibold'>Applicable Levels</td>
                                                                                    <td>
                                                                                        {couponDetails?.applicableLevels.map((item) => item?.title).join(', ')}
                                                                                    </td>
                                                                                </tr>
                                                                            )}
                                                                            {couponDetails?.dependantCategories?.length > 0 && (
                                                                                <tr>
                                                                                    <td className='fw-semibold'>Dependant Categories</td>
                                                                                    <td>
                                                                                        {couponDetails?.dependantCategories.map((item) => item?.name).join(', ')}
                                                                                    </td>
                                                                                </tr>
                                                                            )}
                                                                            {couponDetails?.dependantProducts?.length > 0 && (
                                                                                <tr>
                                                                                    <td className='fw-semibold'>Dependant Products</td>
                                                                                    <td>
                                                                                        {couponDetails?.dependantProducts.map((item) => item?.name).join(', ')}
                                                                                    </td>
                                                                                </tr>
                                                                            )}
                                                                            {couponDetails?.includedOutlets?.length > 0 && (
                                                                                <tr>
                                                                                    <td className='fw-semibold'>Included Outlets</td>
                                                                                    <td>
                                                                                        {couponDetails?.includedOutlets.map((item) => item?.name).join(', ')}
                                                                                    </td>
                                                                                </tr>
                                                                            )}
                                                                            {couponDetails?.excludedOutlets?.length > 0 && (
                                                                                <tr>
                                                                                    <td className='fw-semibold'>Excluded Outlets</td>
                                                                                    <td>
                                                                                        {couponDetails?.excludedOutlets.map((item) => item?.name).join(', ')}
                                                                                    </td>
                                                                                </tr>
                                                                            )}
                                                                            {couponDetails?.primaryComboCategories?.length > 0 && (
                                                                                <tr>
                                                                                    <td className='fw-semibold'>Primary Combo Categories</td>
                                                                                    <td>
                                                                                        {couponDetails?.primaryComboCategories.map((item) => item?.name).join(', ')}
                                                                                    </td>
                                                                                </tr>
                                                                            )}
                                                                            {couponDetails?.secondaryComboCategories?.length > 0 && (
                                                                                <tr>
                                                                                    <td className='fw-semibold'>Secondary Combo Categories</td>
                                                                                    <td>
                                                                                        {couponDetails?.secondaryComboCategories.map((item) => item?.name).join(', ')}
                                                                                    </td>
                                                                                </tr>
                                                                            )}
                                                                            {couponDetails?.applicableQuantityType && (
                                                                                <tr>
                                                                                    <td className='fw-semibold'>Applicable Quantity Type</td>
                                                                                    <td>{couponDetails?.applicableQuantityType}</td>
                                                                                </tr>
                                                                            )}
                                                                            {couponDetails?.discountPrice && (
                                                                                <tr>
                                                                                    <td className='fw-semibold'>Discount Price</td>
                                                                                    <td className='text-success fw-semibold'>₹. {couponDetails?.discountPrice}</td>
                                                                                </tr>
                                                                            )}
                                                                            {couponDetails?.discountPercent && (
                                                                                <tr>
                                                                                    <td className='fw-semibold'>Discount Percent</td>
                                                                                    <td className='text-success fw-semibold'>{couponDetails?.discountPercent} % OFF</td>
                                                                                </tr>
                                                                            )}
                                                                            {couponDetails?.discountAmount && (
                                                                                <tr>
                                                                                    <td className='fw-semibold'>Discount Amount</td>
                                                                                    <td className='text-success fw-semibold'>₹. {couponDetails?.discountAmount}</td>
                                                                                </tr>
                                                                            )}
                                                                            {couponDetails?.minOrderAmount && (
                                                                                <tr>
                                                                                    <td className='fw-semibold'>Minimum Order Amount</td>
                                                                                    <td className='text-success fw-semibold'>₹. {couponDetails?.minOrderAmount}</td>
                                                                                </tr>
                                                                            )}
                                                                            {couponDetails?.maxDiscountAmount && (
                                                                                <tr>
                                                                                    <td className='fw-semibold'>Maximum Discount Amount</td>
                                                                                    <td className='text-success fw-semibold'>₹. {couponDetails?.maxDiscountAmount}</td>
                                                                                </tr>
                                                                            )}
                                                                            <tr>
                                                                                <td className='fw-semibold'>Start Time</td>
                                                                                <td className='fw-bold' style={{ color: 'blueviolet' }}>{couponDetails?.startTime}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className='fw-semibold'>End Time</td>
                                                                                <td className='fw-bold' style={{ color: 'blueviolet' }}>{couponDetails?.endTime}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className='fw-semibold'>Valid From</td>
                                                                                <td>{formattedDate(couponDetails?.validityStartDate)}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className='fw-semibold'>Valid Till</td>
                                                                                <td>{formattedDate(couponDetails?.validityEndDate)}</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td className='fw-semibold'>Status</td>
                                                                                <td>
                                                                                    <Badge bg={checkCouponActive(couponDetails) ? "success" : "danger"}>
                                                                                        {checkCouponActive(couponDetails) ? "ACTIVE" : "INACTIVE (Expired)"}
                                                                                    </Badge>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </Table> */}

                                    <Row>
                                        {/* LEFT TABLE */}
                                        <Col md={6}>
                                            <Table bordered hover>
                                                <tbody>
                                                    <tr>
                                                        <td className='w-50 fw-semibold'>Title</td>
                                                        <td>{couponDetails?.title}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className='fw-semibold'>Description</td>
                                                        <td>{couponDetails?.description}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className='fw-semibold'>Coupon Code</td>
                                                        <td className='fw-bold' style={{ color: 'blueviolet' }}>
                                                            {couponDetails?.couponCode}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className='fw-semibold'>Usage Type</td>
                                                        <td>{couponDetails?.usageType}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className='fw-semibold'>Order Type</td>
                                                        <td>{couponDetails?.orderType}</td>
                                                    </tr>

                                                    {/* Applicable Days */}
                                                    <tr>
                                                        <td className='fw-semibold'>Applicable Days</td>
                                                        <td>
                                                            {couponDetails?.dayOfWeek === null
                                                                ? "On any day of the week"
                                                                : couponDetails?.dayOfWeek
                                                                    ? getDayOfWeek(couponDetails.dayOfWeek)
                                                                    : "N/A"}
                                                        </td>
                                                    </tr>

                                                    {couponDetails?.maxAddonsAllowed && (
                                                        <tr>
                                                            <td className='fw-semibold'>Maximum Addon Allowed</td>
                                                            <td>{couponDetails?.maxAddonsAllowed}</td>
                                                        </tr>
                                                    )}

                                                    <tr>
                                                        <td className='fw-semibold'>BOGO Coupon</td>
                                                        <td>
                                                            {couponDetails?.isBogoCoupon
                                                                ? <span className='text-success fw-semibold'>YES</span>
                                                                : <span className='text-danger fw-semibold'>NO</span>}
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td className='fw-semibold'>Size Upgrade Coupon</td>
                                                        <td>
                                                            {couponDetails?.newSizeUpgradeAddon
                                                                ? <span className='text-success fw-semibold'>YES</span>
                                                                : <span className='text-danger fw-semibold'>NO</span>}
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td className='fw-semibold'>Combo Category Coupon</td>
                                                        <td>
                                                            {couponDetails?.isComboCategoryCoupon
                                                                ? <span className='text-success fw-semibold'>YES</span>
                                                                : <span className='text-danger fw-semibold'>NO</span>}
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td className='fw-semibold'>MRP Coupon</td>
                                                        <td>
                                                            {couponDetails?.isMrpDiscount
                                                                ? <span className='text-success fw-semibold'>YES</span>
                                                                : <span className='text-danger fw-semibold'>NO</span>}
                                                        </td>
                                                    </tr>

                                                    {couponDetails?.isFreebieCoupon && (
                                                        <>
                                                            <tr>
                                                                <td className='fw-semibold'>Freebie Product</td>
                                                                <td className='text-success fw-semibold'>
                                                                    {couponDetails?.freebieProduct?.name || "N/A"}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className='fw-semibold'>Freebie Quantity</td>
                                                                <td className='text-success fw-semibold'>
                                                                    {couponDetails?.freebieQuantity || 1}
                                                                </td>
                                                            </tr>
                                                        </>
                                                    )}

                                                </tbody>
                                            </Table>
                                        </Col>


                                        {/* RIGHT TABLE */}
                                        <Col md={6}>
                                            <Table bordered hover>
                                                <tbody>

                                                    {couponDetails?.discountPrice && (
                                                        <tr>
                                                            <td className='fw-semibold'>Discount Price</td>
                                                            <td className='text-success fw-semibold'>
                                                                ₹ {couponDetails?.discountPrice}
                                                            </td>
                                                        </tr>
                                                    )}

                                                    {couponDetails?.discountPercent && (
                                                        <tr>
                                                            <td className='fw-semibold'>Discount Percent</td>
                                                            <td className='text-success fw-semibold'>
                                                                {couponDetails?.discountPercent}% OFF
                                                            </td>
                                                        </tr>
                                                    )}

                                                    {couponDetails?.discountAmount && (
                                                        <tr>
                                                            <td className='fw-semibold'>Discount Amount</td>
                                                            <td className='text-success fw-semibold'>
                                                                ₹ {couponDetails?.discountAmount}
                                                            </td>
                                                        </tr>
                                                    )}

                                                    {couponDetails?.minOrderAmount && (
                                                        <tr>
                                                            <td className='fw-semibold'>Minimum Order Amount</td>
                                                            <td className='text-success fw-semibold'>
                                                                ₹ {couponDetails?.minOrderAmount}
                                                            </td>
                                                        </tr>
                                                    )}

                                                    {couponDetails?.maxDiscountAmount && (
                                                        <tr>
                                                            <td className='fw-semibold'>Maximum Discount Amount</td>
                                                            <td className='text-success fw-semibold'>
                                                                ₹ {couponDetails?.maxDiscountAmount}
                                                            </td>
                                                        </tr>
                                                    )}

                                                    <tr>
                                                        <td className='fw-semibold'>Start Time</td>
                                                        <td className='fw-bold' style={{ color: 'blueviolet' }}>
                                                            {couponDetails?.startTime}
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td className='fw-semibold'>End Time</td>
                                                        <td className='fw-bold' style={{ color: 'blueviolet' }}>
                                                            {couponDetails?.endTime}
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td className='fw-semibold'>Valid From</td>
                                                        <td>{formattedDate(couponDetails?.validityStartDate)}</td>
                                                    </tr>

                                                    <tr>
                                                        <td className='fw-semibold'>Valid Till</td>
                                                        <td>{formattedDate(couponDetails?.validityEndDate)}</td>
                                                    </tr>

                                                    <tr>
                                                        <td className='fw-semibold'>Status</td>
                                                        <td>
                                                            <Badge bg={checkCouponActive(couponDetails) ? "success" : "danger"}>
                                                                {checkCouponActive(couponDetails)
                                                                    ? "ACTIVE"
                                                                    : "INACTIVE"}
                                                            </Badge>
                                                        </td>
                                                    </tr>

                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>

                                </div>

                                {/* Terms and Conditions Section */}
                                {couponDetails?.termsAndConditions?.length > 0 && (
                                    <div className="mb-4">
                                        <h5 className="text-center fw-bold text-primary mb-3">TERMS AND CONDITIONS</h5>
                                        <Table bordered hover>
                                            <tbody>
                                                {couponDetails?.termsAndConditions?.map((term, index) => (
                                                    <tr key={index}>
                                                        <td className="fw-semibold text-center">{index + 1}.</td>
                                                        <td>{term}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                )}

                                {/* Users Details Section */}
                                <div className="mb-4">
                                    <h5 className="text-center fw-bold text-primary mb-3">USERS DETAILS</h5>
                                    <Table bordered hover>
                                        <thead>
                                            <tr>
                                                <th className="text-center">SR. No</th>
                                                <th className="text-center">NAME</th>
                                                <th className="text-center">EMAIL ID</th>
                                                <th className="text-center">D.O.B</th>
                                                <th className="text-center">GENDER</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {/* {couponUsers?.map((user, index) => ( */}
                                            <tr >
                                                <td className="text-center">{1}.</td>
                                                <td className="text-center">{couponUsers?.name}</td>
                                                <td className="text-center">{couponUsers?.email}</td>
                                                <td className="text-center">{couponUsers?.dob ? formattedDate(couponUsers?.dob) : "---"}</td>
                                                <td className="text-center">{couponUsers?.gender ? couponUsers.gender : "---"}</td>
                                            </tr>
                                            {/* ))} */}
                                        </tbody>
                                    </Table>
                                </div>
                            </Modal.Body>
                        </Modal>
                    )}

                    {/* Edit Modal */}
                    <EditModal1
                        isVisible={openEditModal}
                        selectedUsers={selectedUsers}
                        setOpenEditModal={setOpenEditModal}
                        setFile={setFile}
                        setSelectedUsers={setSelectedUsers}
                        setCouponData={setCouponData}
                        setFromDate={setFromDate}
                        setToDate={setToDate}
                        setSelectedCategories={setSelectedCategories}
                        setSelectedProducts={setSelectedProducts}
                        userCouponId={userCouponId}
                        fetchData={fetchData}
                        selectedCategories={selectedCategories}
                        selectedProducts={selectedProducts}
                        addonList={addonList}
                        getProductsList={getProductsList}
                        usersInfo={usersInfo}
                        handleSelectUsersChange={handleSelectUsersChange}
                        debouncedGetUsersList={debouncedGetUsersList}
                        categoriesData={categoriesData}
                        handleSelectCategoryChange={handleSelectCategoryChange}
                        productsInfo={productsInfo}
                        handleSelectProductChange={handleSelectProductChange}
                        editOutletData={editOutletData}
                        outletData={outletData}
                        levelsData={levelsData}
                        updatingData={updatingData}
                        setUserCouponId={setUserCouponId}
                        exProductList={exProductList}
                        newSizeAddonsList={newSizeAddonsList}
                        allAddonList={allAddonList}
                        freebieProductsOptions={freebieProductsOptions}
                    />

                    {/* Delete Confirmation Modal */}
                    <Modal show={openDeleteModal} onHide={handleCloseDeleteModal} centered>
                        <Modal.Header closeButton className="bg-danger text-white">
                            <Modal.Title>
                                <i className="ri-alert-line me-2"></i>
                                Confirm Delete
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="text-center mb-3">
                                <i className="ri-delete-bin-7-line text-danger fs-1"></i>
                            </div>
                            <h5 className="text-center mb-3">Delete Coupon Allocation</h5>
                            <p className="text-center text-muted">
                                Are you sure you want to delete this coupon allocation? This action cannot be undone.
                            </p>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="outline-secondary" onClick={handleCloseDeleteModal}>
                                Cancel
                            </Button>
                            <Button variant="danger" onClick={handleDeleteUserCouponAllocation} disabled={isDeleteBtnLoading}>
                                {isDeleteBtnLoading ? (
                                    <>
                                        <Spinner animation="border" size="sm" className="me-2" />
                                        Deleting...
                                    </>
                                ) : (
                                    <>
                                        <i className="ri-delete-bin-line me-1"></i> Delete
                                    </>
                                )}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>

                <style jsx>
                    {`
                        .datepicker-popper {
                            z-index: 9999 !important;
                        }
                    `}
                </style>
            </div>
        </React.Fragment>
    );
};

export default UserCoupon1;